import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { INTEGRATION_LOGO } from "views/settings-integration/constants";

const ZUMPER_BLUE = "#38ccff";
const ZUMPER_HEART = "#e84676";

export const BoomAvatarGlyph = () => (
  <svg viewBox="0 0 24 24" className="size-3.5" aria-hidden="true">
    <path
      d="M1.8 10.5H12.9V21.7H10V15.6L4.6 20.9L2.5 18.8L7.9 13.5H1.8V10.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 2.3H12.9V8.4L18.3 3.1L20.4 5.2L15 10.5H21.1V13.5H15L20.4 18.8L18.3 20.9L14 16.7V9.4H6.7L2.5 5.2L4.6 3.1L10 8.4V2.3Z"
      fill="currentColor"
    />
  </svg>
);

const ZumperAvatarGlyph = () => (
  <svg viewBox="0 0 1024 1024" className="size-3.5" aria-hidden="true">
    <path
      d="M554.295 656.984C562.558 656.984 568.067 662.493 568.067 670.756V811.23C568.067 819.494 573.575 825.003 581.839 825.003H722.313C730.576 825.003 736.085 819.494 736.085 811.23V577.106C736.085 574.352 738.84 571.597 738.84 571.597H785.664C799.436 571.597 807.7 557.825 796.682 546.808L708.541 458.667C705.787 455.912 705.787 453.158 705.787 447.649V340.228C705.787 331.964 700.278 326.456 692.015 326.456H636.927C628.663 326.456 623.155 331.964 623.155 340.228V376.035L521.242 274.122C515.733 268.613 507.47 268.613 501.961 274.122L226.521 549.562C218.257 557.825 223.766 574.352 237.538 574.352H284.363C287.117 574.352 289.872 577.106 289.872 577.106V811.23C289.872 819.494 295.381 825.003 303.644 825.003H444.118C452.382 825.003 457.89 819.494 457.89 811.23V670.756C457.89 662.493 463.399 656.984 471.662 656.984H554.295Z"
      fill="currentColor"
    />
    <path
      d="M738.843 180.471C733.334 130.892 681 136.4 667.228 177.716C667.228 180.471 664.474 180.471 664.474 177.716C647.947 133.646 592.859 133.646 590.105 185.98C590.105 232.804 642.439 254.84 661.719 285.138C664.474 287.892 667.228 287.892 669.983 285.138C689.264 252.085 744.352 227.296 738.843 180.471Z"
      fill={ZUMPER_HEART}
    />
  </svg>
);

export const ChannelAvatar = ({ id }: { id: IntegrationId }) => {
  if (id === IntegrationId.ZUMPER)
    return (
      <span
        className="flex size-full items-center justify-center text-white"
        style={{ backgroundColor: ZUMPER_BLUE }}
      >
        <ZumperAvatarGlyph />
      </span>
    );

  const logo = INTEGRATION_LOGO[id];
  if (!logo) return null;

  return logo.Icon ? (
    <logo.Icon className="size-full object-cover" />
  ) : (
    <img
      src={logo.src}
      alt=""
      aria-hidden="true"
      className="size-full object-cover"
    />
  );
};
